import React from 'react'

import { useTheme } from '@mui/material'

import { getInitials } from '../../helpers'

interface CustomStyles {
    container?: React.CSSProperties
    text?: React.CSSProperties
    image?: React.CSSProperties
}

interface IAvatarCircleProps {
    styles?: CustomStyles
    text?: string
    image?: string
    initials?: boolean
    changePicMode?: boolean
    onInputChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
    addImageIcon?: boolean
    tooltip?: string
}

export const AvatarCircle = React.forwardRef<
    HTMLDivElement,
    IAvatarCircleProps
>((props, ref) => {
    const theme = useTheme()
    const containerStyle: React.CSSProperties = {
        borderRadius: '100%',
        backgroundColor: theme.palette.info.light,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: theme.palette.common.white,
        position: 'relative',
        cursor: 'pointer',
        ...props.styles?.container,
    }

    const imageStyle: React.CSSProperties = {
        borderRadius: '100%',
        height: '100%',
        width: '100%',
    }

    let text = props.text ? props.text : ''
    if (text !== '' && props.initials) {
        //parse the string to get just the initials
        text = getInitials(text)
    }
    return (
        <div
            {...props}
            style={{
                minHeight: 40,
                maxHeight: 40,
                minWidth: 40,
                maxWidth: 40,
                ...containerStyle,
            }}
            ref={ref}
        >
            {props.image ? (
                <img
                    src={props.image}
                    style={{
                        ...imageStyle,
                        minHeight: '40px',
                        maxHeight: '40px',
                        minWidth: '40px',
                        maxWidth: '40px',
                    }}
                />
            ) : (
                <span style={props.styles?.text}>{text}</span>
            )}
        </div>
    )
})
